<template>
  <div
      @click.stop="preventClick" >
    <segmented-control
        v-if="variant === 'panel' && activeObject && showColorPicker && !hideModeChangeButtons && canUseGradientMode"
        :class="{'px-0': activeObject.type == 'image' && (activeObject.ImageType.indexOf('FDICText') !== -1 || activeObject.ImageType.indexOf('FDICLogo') !== -1)}"
        :options="modeOptions"
        :value="!!isGradientPicker"
        class="color-mode-tabs"
        @input="onPanelModeSelect"/>
    <div
        v-else-if="activeObject && showColorPicker && !hideModeChangeButtons && canUseGradientMode"
        :class="{'px-0': activeObject.type == 'image' && (activeObject.ImageType.indexOf('FDICText') !== -1 || activeObject.ImageType.indexOf('FDICLogo') !== -1)}"
        class="btn-group color-option"
        role="group"
        aria-label="Basic radio toggle button group">
      <input
          id="btnradio1"
          :checked="!isGradientPicker"
          type="radio"
          class="btn-check"
          name="btnradio"
          autocomplete="off"
          @change="onModeChange(false)">
      <label
          class="btn btn-picker-type"
          for="btnradio1">Solid Color</label>

      <input
          id="btnradio2"
          :checked="isGradientPicker"
          type="radio"
          class="btn-check"
          name="btnradio"
          autocomplete="off"
          @change="onModeChange(true)">
      <label
          class="btn btn-picker-type"
          for="btnradio2">Gradient</label>
    </div>
    <color-picker
        :color="selectedColorValue"
        :sucker-hide="true"
        :sucker-canvas="suckerCanvas"
        :sucker-area="suckerArea"
        :colors-default="['#000000', '#FFFFFF', '#FF1900', '#F47365', '#FFB243', '#FFE623', '#6EFF2A', '#1BC7B1', '#00BEFF', '#2E81FF', '#5D61FF', '#FF89CF', '#FC3CAD', '#BF3DCE', '#8E00A7','#927549']"
        :colors-history-key="'none'"
        :display-style="displayStyle"
        :hide-palettes="colorType === 'table-fill'"
        :hide-alpha="hideAlpha"
        :active-object="activeObject"
        :show-gradient="isGradientPicker"
        :variant="variant"
        theme="dark"
        @updateSelectedPointPosition="updateSelectedPointPosition"
        @updateSelectedPointOfGradient="updateSelectedPointOfGradient"
        @changeColor="changeColor"
        @openSucker="openSucker"
        @updateSelectedGradientAngle="updateSelectedGradientAngle"

    />
  </div>
</template>

<script>
import Color from '@/components/BMColorPicker';
import SegmentedControl from '@/components/LeftSection/ui/SegmentedControl';
import { rgbToCmyk } from '@/components/Helper';
import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes'; // TDOD: Change to @/
import { findObjectById } from '@/components/Canvas/utils/groupHelpers';

export default {
  name: 'ColorPicker',

  components: { 'color-picker': Color, 'segmented-control': SegmentedControl },
  props:      {
    color: String,
    type:  {
      type:    String,
      default: 'text',
    },
    displayStyle: {
      type:    String,
      default: 'inline',
    },
    colorType: {
      type:    String,
      default: 'fill',
    },
    activeObject: {
      type:    Object,
      default: () => {
      },
    },
    isForShadowColor: {
      type:    Boolean,
      default: false,
    },
    selectedObjectsList: {
      type:    Array,
      default: () => [],
    },
    contentList: {
      type:    Array,
      default: () => [],
    },
    showGradient: {
      type:    Boolean,
      default: false,
    },
    hideModeChangeButtons: {
      type:    Boolean,
      default: false,
    },
    hideAlpha: {
      type:    Boolean,
      default: false,
    },
    variant: {
      type:    String,
      default: 'default',
    },
  },
  data() {
    return {
      suckerCanvas:       null,
      suckerArea:         [],
      isSucking:          false,
      boundingReact:      null,
      selectedColorValue: this.color,
      modeOptions:        [
        { value: false, label: 'Solid Color' },
        { value: true, label: 'Gradient' },
      ],
    };
  },
  computed: {
    showColorPicker() {
      if (this.activeObject.type === 'shape' || this.activeObject.ImageType === 'SVGImage') { return true; }
      if (this.activeObject.ImageType && (this.activeObject.ImageType.indexOf('FDICText') !== -1 || this.activeObject.ImageType.indexOf('FDICLogo') !== -1)) { return true; }
      return false;
    },
    canUseGradientMode() {
      return this.colorType !== 'shadow'
          && this.colorType !== 'text-shadow'
          && this.colorType !== 'outline'
          && this.colorType !== 'table-fill';
    },
    isGradientPicker() {
      if (!this.canUseGradientMode) { return false; }
      return (this.activeObject) ? this.activeObject.isGradient : this.showGradient;
    },
    getPositionClass() {
      if (this.position === 'float') {
        return 'position-fixed ';
      }
      return '';
    },
    colorPickerColor() {
      return this.selectedColorValue;
    },
  },
  mounted() {
    console.log('mounted ColorPicker', this.activeObject);
  },
  methods: {
    updateSelectedGradientAngle(angle) {
      this.$emit('updateSelectedGradientAngle', angle);
    },
    updateSelectedPointPosition(position) {
      console.log('ColorPicker file updateSelectedPointPosition', position);
      // console.log('Index file updateSelectedPointPosition', position);
      this.$emit('updateSelectedPointPosition', position);
    },
    updateSelectedPointOfGradient(index) {
      this.$emit('updateSelectedPointOfGradient', index);
    },
    onModeChange(showGradient) {
      this.$emit('changeMode', showGradient);
    },
    onPanelModeSelect(showGradient) {
      if (showGradient !== !!this.isGradientPicker) {
        this.onModeChange(showGradient);
      }
    },

    preventClick() {
    },


    changeColor(color) {
      if (this.colorType === 'table-fill') {
        this.selectedColorValue = color.hex;
        this.$emit('color-changed', {
          colorType: 'table-fill',
          rgba:      `rgba(${color.rgba.r}, ${color.rgba.g}, ${color.rgba.b}, ${color.rgba.a})`,
          hex:       color.hex,
        });
        return;
      }
      const targets = (this.selectedObjectsList && this.selectedObjectsList.length)
          ? this.selectedObjectsList
          : [{ Id: this.activeObject && this.activeObject.Id }];
      const Rgb = `rgba(${color.rgba.r}, ${color.rgba.g}, ${color.rgba.b}, ${color.rgba.a})`;

      if (this.colorType === 'outline') {
        this.selectedColorValue = color.hex;
        this.$emit('color-changed', { colorType: 'outline', rgba: Rgb, hex: color.hex });
      }
      if (this.selectedObjectsList.length > 1) {
        this.selectedObjectsList.forEach((object) => {
          console.log('object.Id', object.Id);
          console.log('object', object);
          this.changeColorById(color, object.Id);
        });
      } else {
        const id = (this.selectedObjectsList[0] && this.selectedObjectsList[0].Id)
            || (this.activeObject && this.activeObject.Id);
        this.changeColorById(color, id);
      }
      EventBus.$emit('addIntoPageWiseUndoRedoArray', 'Color Change');
    },

    changeColorById(color, objectId = '') {
      const selectObject = objectId != '' ? findObjectById(this.contentList, objectId) : this.activeObject;
      if (!selectObject) { return; }
      this.selectedColorValue = color.hex;
      const Rgb = `rgba(${color.rgba.r}, ${color.rgba.g}, ${color.rgba.b}, ${color.rgba.a})`;
      console.log('Color Type is ', this.colorType);
      if (this.colorType == 'shadow') {
        if ((selectObject.type == 'shape' || selectObject.type == 'image' || (selectObject.ImageType == 'SVGImage' || selectObject.ImageType.indexOf('FDICText') !== -1 || selectObject.ImageType.indexOf('FDICLogo') !== -1)) && selectObject.shadow) {
          selectObject.shadow.color = Rgb;
          EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_SHAPE_SHADOW_COLOR, Rgb, selectObject.Id);
        }
        return;
      }
      if (this.colorType == 'text-shadow') {
        if (selectObject.textShadow.textEffect === 'shadow') {
          EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_TEXT_SHADOW_COLOR, Rgb, selectObject.Id);
        } else if (selectObject.outLine.textEffect === 'outline') {
          EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_TEXT_OUTLINE_COLOR, Rgb, selectObject.Id);
        }
        return;
      }
      if (selectObject.type == 'image' && this.colorType === 'outline' && (selectObject.ImageType !== 'SVGImage' && selectObject.ImageType.indexOf('FDICText') === -1 && selectObject.ImageType.indexOf('FDICLogo') === -1)) {
        if (!selectObject.outline) {
          selectObject.outline = {};
        }
        selectObject.outline.color = Rgb;
        this.changeImageBorderColorInUiById(selectObject.Id, Rgb);

        const boxes = document.querySelectorAll('.effect-box');
        boxes.forEach((box) => {
          box.style.background = Rgb;
        });
        EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.UPDATE_IMAGE_BORDER_COLOR, Rgb);
        // EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, this.contentList);
        return;
      }
      const objectType = this.getObjectType(selectObject.Id);
      if ((objectType == 'text' || objectType == 'table') && !this.isGradientPicker) {
        if (this.colorType == 'fill') {
          EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_TEXT_COLOR, Rgb, selectObject.Id);
        } else if (this.colorType == 'outline') {
          EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_TEXT_OUTLINE_COLOR, Rgb, selectObject.Id);
        } else {
          EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_TEXT_SHADOW_COLOR, Rgb, selectObject.Id);
        }
        return;
      }
      if (this.getObjectType(selectObject.Id) == 'shape') {
        if (this.colorType == 'fill') {
          EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_SHAPE_COLOR, Rgb, selectObject.Id);
        }
        if (this.colorType == 'outline') {
          EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_SHAPE_STROKE, Rgb, selectObject.Id);
        }
        return;
      }
      if ((this.getObjectType(selectObject.Id) == 'SVGImage' || this.getObjectType(selectObject.Id).indexOf('FDICText') !== -1 || this.getObjectType(selectObject.Id).indexOf('FDICLogo') !== -1) && !this.isGradientPicker) {
        if (this.colorType === 'fill') {
          EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_SVG_FILL_COLOR, Rgb, selectObject.Id);
        }
        if (this.colorType === 'outline') {
          EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_SVG_STROKE_COLOR_BY_ID, Rgb, selectObject.Id);
        }
      } else {
        this.colorType === 'fill' && EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_SHAPE_COLOR, Rgb, selectObject.Id);

        this.colorType === 'outline' && EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_SVG_STROKE_COLOR_BY_ID, Rgb, selectObject.Id);
      }
    },

    changeImageBorderColorInUiById(id, newColor) {
      // console.log('changeImageBorderColorInUiById', id);
      const elemSelector = `.canvas-non-play-all [id='${id}']`;
      const elem         = document.querySelector(elemSelector);
      if (!elem) { return; }

      const style = window.getComputedStyle(elem);
      let filter  = style.filter;

      // Ensure it's a string
      if (!filter || filter === 'none') {
        console.warn('No drop-shadow filter found on element:', id);
        return;
      }

      // Force to string (in case some browsers give CSSStyleValue object)
      filter = String(filter);

      // Replace the color inside each drop-shadow()
      const updatedFilter = filter.replace(
          /drop-shadow\(\s*(#[0-9a-fA-F]{3,8}|rgba?\([^)]*\)|[a-zA-Z]+)([^)]*)\)/g,
          (_, _oldColor, rest) => `drop-shadow(${newColor}${rest})`,
      );

      // console.log("Updated filter:", updatedFilter);
      elem.style.filter = updatedFilter;
    },

    openSucker(isOpen) {
      alert(isOpen);
      if (isOpen) {
        this.suckerCanvas  = document.getElementById('main_html');
        this.boundingReact = document.getElementById('main_html').getBoundingClientRect();
        this.suckerArea    = [this.boundingReact.left, this.boundingReact.top, this.boundingReact.right, this.boundingReact.bottom];
      } else {
        this.suckerCanvas && this.suckerCanvas.remove;
      }
    },

    getObjectType(objectId) {
      const selectedObject = findObjectById(this.contentList, objectId);
      if (!selectedObject) { return 'shape'; }
      if (selectedObject.type == 'text') {
        return selectedObject.type;
      }
      if (selectedObject.type == 'image') {
        return selectedObject.ImageType;
      }
      if (selectedObject.type == 'shape') {
        return selectedObject.type;
      }
      if (selectedObject.type == 'table') {
        return selectedObject.type;
      }
      return selectedObject.type || 'shape';
    },
  },
};

</script>
<style scoped lang="scss">

.btn-check{
  &:checked{
    + .btn-picker-type.btn {
      color: #3bb0fa !important;
      border-color: #3bb0fa !important;
      border-radius: 3px !important;
    }
  }
  + .btn-picker-type.btn{
    margin: 0px 10px;
    border:1px solid #ededed;
    font-size: 1.2rem;
  }
}

#picker-wrapper {
  width: 200px;
  height: 200px;
  position: relative;
}

#slider-wrapper {
  width: 30px;
  height: 200px;
  position: relative;
}

#picker-indicator {
  width: 3px;
  height: 3px;
  position: absolute;
  border: 1px solid white;
}

#slider-indicator {
  width: 100%;
  height: 10px;
  position: absolute;
  border: 1px solid black;
}

.color-option {
  width: 100%;
  margin-bottom: 10px;
}

.color-mode-tabs {
  margin-bottom: 14px;
}

</style>
